module.exports = __webpack_public_path__ + "img/jack-after.60801c6e.png";